var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"blogDetailContainer",attrs:{"src":_vm.$route.params.url,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }